<template>
  <modal
    :name="name"
    @before-open="beforeOpen"
    @before-close="beforeClose"
    width="70%"
    height="70%"
    class="modal-filter-selection-params"
  >
    <div class="params-header">
      <div class="tab-bar">
        <div
          :class="['options-tab', optIndex == activeOptionIndex && 'active']"
          v-for="(optionType, optIndex) in dynamicFiltersOptionsTypes"
          :key="optionType"
          @click="() => activeOptionIndex =  optIndex"
        >{{$t(optionType)}} <span v-if="currentFilter[optionType] && currentFilter[optionType].length > 0">({{currentFilter[optionType].length}})</span></div>
      </div>
      <div class="modal-actions">
        <button class="btn btn--primary" @click="clearFilter" v-if="filterChanged">Clear all filters</button>
        <button class="btn btn--secondary" @click="applyFilter">Apply filter</button>
      </div>
    </div>

    <div class="tab-content" v-if="loadedValues && filterTemplate">
      <div class="options-list column">
        <div class="column-header">Choose filter configuration</div>
        <template>
          <trial-option-card
            v-for="(opt, optIndex) in currentFilteringOptions"
            :key="'option-' + opt.id + '-' + optIndex"
            :optionType="activeOptionType"
            :option="opt"
            hideImage="false"
            :hasValues="isOptionLive(opt)"
            v-show="!isOptionLive(opt)"
            @addOption="openParamConfig"
            @configureOption="openParamConfig"
            @removeOption="removeParam"
            addLabel="add_filter"
            editLabel="edit_filter"

          ></trial-option-card>
          <div class="no-filters" v-if="nonSelectedOption.length == 0">
            All configurations were selected
          </div>
        </template>
      </div>
      <div class="current-config column">
        <div class="current-config-container">
          <div class="recap-option-name column-header">{{$t(activeOptionType)}} filter configuration recap</div>
          <div class="recap-block" v-if="currentFilter[activeOptionType] && currentFilter[activeOptionType].length > 0">
            <trial-option-recap
              ref="recap"
              :optionType="activeOptionType"
              :values="currentFilter[activeOptionType]"
              :isEditable="true"
              @edit="onRecapEdit"
              @remove="removeParam"
            />
          </div>
          <div class="no-filters" v-else>
            No filter added
          </div>
        </div>
      </div>
      <modal-option-config name="param-config" @save="onParamSave" width="70%" height="70%"></modal-option-config>
      <loading-overlay v-if="isLoading"></loading-overlay>  
    </div>
  </modal>
</template>

<script>
import Vue from 'vue'
import Api from '@/api'
import { mapState } from "vuex";

import { getValueTypeKey, getOption, setOption, getSegmentsWithValuesForProject} from '@/utils/ConfigUtils'

import trialConfig from '@/mixins/trialConfig'
import ModalOptionConfig from '@/components/modals/ModalOptionConfig'
import TrialOptionCard from '@/components/trial/TrialOptionCard'
import TrialOptionRecap from '@/components/trial/TrialOptionRecap'
import ParametersConfig from '@/components/ParametersConfig'
import {getColorScales} from '@/utils/colorScales'

export default {
  name: 'ModalSelectionParams',
  components: {TrialOptionCard,TrialOptionRecap,ModalOptionConfig,ParametersConfig},
  props: ['name'],
  mixins: [trialConfig],
  data() {
    return {
      // currentTabComponent: OptionConfig,
      filterTemplate: null,
      currentFilter: {},
      loadedValues: false,
      activeOptionIndex: 0,
      filtersOptionsTypes: ['population_params','diseases', 'treatments', 'resultScalars'], //ya lo pone el mixin
      mergedValues: {},
      isLoading: false,
      filterChanged: false,
    }
  },
  computed: {
    ...mapState({
      optionsLoaded: state => state.trialOptions.loaded,
      optionsLists: state => state.trialOptions.data
    }),
    dynamicFiltersOptionsTypes () {
      return this.filterTemplate ? this.filtersOptionsTypes.filter(type => this.filterTemplate[type]) : []
    },
    activeOptionType () {
      return this.dynamicFiltersOptionsTypes[this.activeOptionIndex]
    },
    activeOptionsList() {
      return this.dynamicFiltersOptionsTypes[this.activeOptionTypeIndex]
    },
    activeRecapTypes () {
      return this.dynamicFiltersOptionsTypes.filter((type)=>{
        return this.hasLiveValues(type)
      })
    },
    currentFilteringOptions() {
      if (this.activeOptionType == 'populations') {
        return this.filterTemplate[this.activeOptionType].length > 0 ? this.filterTemplate[this.activeOptionType][0].parameters : []
      }
      return this.filterTemplate[this.activeOptionType]
    },
    nonSelectedOption(){
      return this.currentFilteringOptions.filter(opt => !this.isOptionLive(opt))
    }
  },
  created () {
    /*this.trial = {cohortGeneration:{population:this.dynamicOptionsTypes.reduce((ob,key)=> (ob[key]=[],ob),{})}}
    // populations.parameters are added by default
    this.trial.cohortGeneration.population.parameters = this.optionsLists.parameters
    this.loadedValues = true*/
  },
  methods: {
    beforeOpen(event) {
      this.project = event.params.project
      this.trial = event.params.trial

      this.loadedValues = false
      this.projectName = this.project.name
      this.activeOptionIndex = 0
      Api.getFilterTemplate(this.project).then(resp => {
        this.filterTemplate = resp
        // copy population params to same level of others
        if (resp.population_general_characteristics.length > 0 ){
          this.filterTemplate.population_params = resp.population_general_characteristics.map((par, index) => {
            return {
              ...par,
              id: index
            }
          })
        }
        else {
          this.filterTemplate.population_params = []
        }

        //Fix to avoid issues with all -1 ids
        this.filterTemplate.resultScalars = resp.resultScalars.map((e,index) => {
          return {
            ...e,
            id: e.id == -1 ? index : e.id
          }
        })
        if(!this.currentFilter){
          this.currentFilter = {
            projectId: resp.projectId,
            populations: resp.populations
          }
          this.filterChanged = false
        }
        this.loadedValues = true

      })
    },
    closeModal(){
      this.$modal.hide(this.name)
    },
    beforeClose() {
      this.isLoading = false
      
      clearTimeout(this.reqToken)
    },
    onParamSave({paramConfig,value}){
      this.filterChanged = true
      if(!this.currentFilter[this.activeOptionType]) {
        this.currentFilter[this.activeOptionType] = []
      }
      let popArray = this.currentFilter[this.activeOptionType]
      let candidate = popArray.find((d)=>d.id===paramConfig.option.id)
      if(candidate) popArray.splice(popArray.indexOf(candidate),1,value)
      else popArray.push(value)

      this.currentFilter[this.activeOptionType] = JSON.parse(JSON.stringify(popArray))

      this.currentFilter = Object.assign({}, this.currentFilter)
    },
    applyFilter () {
      this.isLoading=true
      
      let filterConfig = Object.assign({}, this.currentFilter)
      filterConfig.population_general_characteristics = filterConfig.population_params
      delete filterConfig.population_params
      /// Old implementation
      // this.reqToken = Api.getProjectResults(this.project.id, filterConfig).then((res)=>{
      //   this.isLoading=false
      //   this.$emit('complete', res)
      //   this.$modal.hide(this.name)
      // })
      this.$emit('filterConfig', filterConfig)
      this.$modal.hide(this.name)
    },
    
    openParamConfig (paramConfig, isActive = false) {
      // let optArray = this.trial.cohortGeneration.population[paramConfig.optionType]
      let optArray = getOption(this.filterTemplate,paramConfig.optionType, true)
      let currentValue, values
      if (isActive) {
        currentValue = paramConfig.option
      } else {
        currentValue = optArray && optArray.find((d)=>d.id === paramConfig.option.id)
      }
      //let currentValue = paramConfig
      if(currentValue) {
        values = JSON.parse(JSON.stringify(currentValue))
      } else {
        let config = this.optionsLists[paramConfig.optionType].find((d)=>d.id === paramConfig.option.id)
        values = JSON.parse(JSON.stringify(config))
      } 
      let markedSegments = getSegmentsWithValuesForProject(this.project, paramConfig)
      // let idx
      // if(paramConfig.optionType==='diseases') idx = 1
      // else if (paramConfig.optionType==='treatments') idx = 2
      // let colorScale = this.$refs.recap[idx].nextColorScale()
      let colorScale = paramConfig.colorScale || (this.$refs.recap ? this.$refs.recap.nextColorScale() : getColorScales(paramConfig.optionType,1)[0])
      this.$modal.show('param-config', {
        paramConfig: {
          ...paramConfig,
          colorScale: colorScale
        },
        values: values,
        markedSegments: markedSegments
      })
    },
    removeParam (paramConfig){
      // this.trial.cohortGeneration.population[paramConfig.optionType] = this.trial.cohortGeneration.population[paramConfig.optionType].filter((d)=>d.id!==paramConfig.option.id)
      let optArray = getOption(this.currentFilter,paramConfig.optionType, true)
      let newValue = optArray.filter((d)=>d.id!==paramConfig.option.id)
      setOption(this.currentFilter,paramConfig.optionType,newValue, true)
    },    
   
    onRecapEdit (paramConfig) {
      this.activeOptionIndex = this.dynamicFiltersOptionsTypes.findIndex((o)=>o === paramConfig.optionType)
      this.openParamConfig(paramConfig, true)
    },
    isOptionLive (option) {
      return this.currentFilter[this.activeOptionType] && this.currentFilter[this.activeOptionType].find(el => el.id == option.id)
    },
    clearFilter () {
      this.filterChanged = false
      this.currentFilter = {
        projectId: this.filterTemplate.projectId,
        populations: this.filterTemplate.populations
      }
    }
  },
  watch: {
    trial () {
      // this.setMergedValues()
    },
    optionsLoaded () {
      // this.setMergedValues()
    }
  }
}
</script>

<style lang="stylus">
.modal-filter-selection-params
  .vm--modal
    background: $athens-gray
    background: linear-gradient(180deg, $athens-gray 0, $mischka 100%)
    height: 100%
    margin: 0

    .params-header
      align-items: center
      border-bottom: 1px solid #fff
      display: flex
      height: 50px
      margin: 0 20px

      .modal-actions
        display flex
        margin-left: auto
        max-height 32px

      .tab-bar
        display: flex

        .options-tab
          color: $gull-gray
          cursor: pointer
          justify-content: center
          m-font-size(14, 18)
          margin-right: 10px
          padding-bottom: 4px
          position: relative

          &:after
            background-color: $radical-red
            bottom: 0
            content: ""
            height: 2px
            left: 0
            position: absolute
            transition: width 0.25s ease-in-out
            width: 0

          &:hover
            color: #000

          &.active
            color: #000
            cursor: default

            &:after
              width: 100%

    .tab-content
      display: flex
      height: calc(100% - 80px)
      margin: 10px 20px

      .options-list
        border-right: 1px solid #fff
        flex: 1 1 33%
        height: 100%
        margin-right: 15px
        padding-right: 15px
        overflow auto

      .current-config
        flex: 1 1 66%
        height: 100%
        overflow auto


      .column-header
        color: $river-bed
        m-font-size(10, 12)
        margin-bottom: 10px
        text-transform: uppercase
        

  .no-filters
    color $storm-gray
    opacity 0.5
    margin-top 15px

  .trial-option-card
    border-bottom 1px solid #fff !important
</style>